module.exports = __webpack_public_path__ + "static/media/mongodb_logo.3d40302b.png";